import { S3Document } from "./fnolRequest";

export class Claim {
  identifier: string;
  claim_date: string;
  notification_date: string;
  paid_amount?: number;
  expense?: number;
  used_franchsie?: number;
  status: ClaimStatus;
  closing_reason?: string;
  closing_date?: string;
  type?: string;
  sub_type?: string;
  cause?: string;
  insured_event?: boolean;
  reason_why_not_insured?: string;
  deduction_yearly_franchise?: number;
  deduction_percentage_deductible?: number;
  deduction_deductible?: number;
  benefit_amount?: number;
  expected_date?:Date;
  deduction_non_covered_positions?: number;
  deduction_discount?: number;
  deduction_others?: number;
  precedent_claim_id?: string;
  fnolRequestId?: string;
  invoiceDocument?: S3Document | null;

  constructor(
    identifier: string, claim_date: string, notification_date: string, paid_amount: number, expense: number,
    used_franchise: number, status: ClaimStatus, closing_reason: string, closing_date: string, type: string,
    sub_type: string, cause: string, insured_event: boolean, reason_why_not_insured: string,
    deduction_yearly_franchise: number, deduction_percentage_deductible: number,
    deduction_deductible: number, benefit_amount: number
  ) {
    this.identifier = identifier;
    this.claim_date = claim_date;
    this.notification_date = notification_date;
    this.paid_amount = paid_amount;
    this.expense = expense;
    this.used_franchsie = used_franchise;
    this.status = status;
    this.closing_reason = closing_reason;
    this.closing_date = closing_date;
    this.type = type;
    this.sub_type = sub_type;
    this.cause = cause;
    this.insured_event = insured_event;
    this.reason_why_not_insured = reason_why_not_insured;
    this.deduction_yearly_franchise = deduction_yearly_franchise;
    this.deduction_percentage_deductible = deduction_percentage_deductible;
    this.deduction_deductible = deduction_deductible;
    this.benefit_amount = benefit_amount;
  }
}

export enum ClaimStatus {
  NEW = "NEW",
  IN_PROGRESS = "IN_PROGRESS",
  DONE = "DONE", // when get from cms
  COMPLETED = "Geschlossen" // when get from ci
}
